(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bundle-offer-block')) {
    const QTY_MINUS_SVG =
      '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.75 7H11.25" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
    const QTY_PLUS_SVG =
      '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.75 7H11.25" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><path d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
    const REMOVE_SVG =
      '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><path d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function escapeHtml(value) {
      const div = document.createElement('div');
      div.textContent = value == null ? '' : String(value);
      return div.innerHTML;
    }

    // Minimal money formatter (mirrors assets/money-formatting.js) so a
    // line's price can be recalculated as unit price × quantity — the
    // server only ever sends us a single unit's formatted price string,
    // which can't be multiplied directly.
    const CURRENCY_DECIMALS = { BHD: 3, BIF: 0, CLP: 0, DJF: 0, GNF: 0, ISK: 0, JOD: 3, JPY: 0, KMF: 0, KRW: 0, KWD: 3, PYG: 0, RWF: 0, UGX: 0, VND: 0, VUV: 0, XAF: 0, XOF: 0, XPF: 0 };

    function formatMoneyCents(cents, format, currency) {
      const precision = CURRENCY_DECIMALS[(currency || '').toUpperCase()] ?? 2;
      const divisor = Math.pow(10, precision);
      return String(format || '{{ amount }}').replace(/{{\s*(\w+)\s*}}/g, (_, placeholder) => {
        let thousands = ',';
        let decimal = '.';
        let p = precision;
        switch (placeholder) {
          case 'amount_no_decimals':
            p = 0;
            break;
          case 'amount_with_comma_separator':
            thousands = '.';
            decimal = ',';
            break;
          case 'amount_no_decimals_with_comma_separator':
            thousands = '.';
            p = 0;
            break;
          case 'amount_no_decimals_with_space_separator':
            thousands = ' ';
            p = 0;
            break;
          case 'amount_with_space_separator':
            thousands = ' ';
            decimal = ',';
            break;
          case 'amount_with_period_and_space_separator':
            thousands = ' ';
            decimal = '.';
            break;
          case 'amount_with_apostrophe_separator':
            thousands = "'";
            decimal = '.';
            break;
          default:
            break;
        }
        const rounded = (cents / divisor).toFixed(p);
        let [whole, frac] = rounded.split('.');
        whole = (whole || '0').replace(/\d(?=(\d\d\d)+(?!\d))/g, (d) => d + thousands);
        return p <= 0 ? whole : whole + decimal + (frac || '').padEnd(p, '0');
      });
    }

    class BundleOfferBlock extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        const configEl = this.querySelector('[data-bundle-config]');
        if (!configEl) return;

        let config;
        try {
          config = JSON.parse(configEl.textContent);
        } catch (err) {
          console.error('[bundle-builder] Invalid config JSON', err);
          return;
        }

        this.products = Array.isArray(config.products) ? config.products : [];
        this.required = Math.max(1, parseInt(config.requiredQuantity, 10) || 1);
        // 0/falsy means this offer has no upper limit (e.g. "buy 3 or more").
        this.maxQuantity = parseInt(config.maxQuantity, 10) || 0;
        this.discount = config.discountPercent;
        this.buttonTemplate = config.buttonTemplate || 'Add {quantity} items to cart';
        this.showPrices = !!config.showPrices;
        this.showQty = !!config.showQty;
        this.showRemove = !!config.showRemove;
        this.offerLabel = config.offerLabel || '';
        this.moneyFormat = config.moneyFormat || '{{ amount }}';
        this.currencyCode = config.currencyCode || 'USD';

        // Selection is tracked per VARIANT (not per product) so that two
        // different variants of the same product count as two separate
        // bundle items, while the same variant picked twice is one entry
        // whose qty is incremented (and priced accordingly).
        // variantId (string) -> { productId, qty, variantId, price, discountedPrice, image, choices }
        this.selected = new Map();
        // productId -> { color, size } — in-progress swatch picks not yet resolved to a variant
        this.pendingChoices = new Map();

        this.grid = this.querySelector('[data-product-grid]');
        this.counterEl = this.querySelector('[data-selection-counter]');
        this.listEl = this.querySelector('[data-selected-list]');
        this.addBtn = this.querySelector('[data-add-to-cart]');
        this.errorEl = this.querySelector('[data-bundle-error]');
        this.labelEl = this.addBtn ? this.addBtn.querySelector('[data-button-label]') : null;

        if (this.grid) {
          this.grid.addEventListener('click', (event) => this.handleGridClick(event));
        }

        if (this.listEl) {
          this.listEl.addEventListener('click', (event) => {
            const row = event.target.closest('[data-selected-row]');
            if (!row) return;
            const key = row.getAttribute('data-entry-key');
            if (event.target.closest('[data-qty-minus]')) {
              this.changeQty(key, -1);
            } else if (event.target.closest('[data-qty-plus]')) {
              this.changeQty(key, 1);
            } else if (event.target.closest('[data-remove]')) {
              this.removeProduct(key);
            }
          });
        }

        if (this.addBtn) {
          this.addBtn.addEventListener('click', () => this.addToCart());
        }

        this.render();
      }

      findProduct(id) {
        return this.products.find((product) => String(product.id) === String(id));
      }

      // True if at least one variant of this product currently has a
      // selected entry (a product can have more than one selected variant).
      isProductSelected(productId) {
        for (const entry of this.selected.values()) {
          if (String(entry.productId) === String(productId)) return true;
        }
        return false;
      }

      // Total quantity across all selected products/variants — this is what
      // counts toward the bundle requirement, not the number of unique
      // products selected (e.g. one product at qty 2 counts as 2 items).
      totalQty() {
        let total = 0;
        this.selected.forEach((entry) => {
          total += entry.qty || 0;
        });
        return total;
      }

      handleGridClick(event) {
        const swatchBtn = event.target.closest('[data-option-value]');
        if (swatchBtn) {
          if (swatchBtn.disabled) return;
          const card = swatchBtn.closest('[data-product-id]');
          if (!card || card.classList.contains('is-disabled')) return;
          const row = swatchBtn.closest('[data-option-type]');
          if (!row) return;
          const optionType = row.getAttribute('data-option-type');
          const id = card.getAttribute('data-product-id');
          this.selectSwatch(id, optionType, swatchBtn.getAttribute('data-option-value'));
          return;
        }

        const confirmBtn = event.target.closest('[data-select-variant]');
        if (confirmBtn) {
          if (confirmBtn.disabled) return;
          const card = confirmBtn.closest('[data-product-id]');
          if (!card) return;
          this.confirmSelection(card.getAttribute('data-product-id'));
          return;
        }

        const selectBtn = event.target.closest('[data-select-toggle]');
        if (selectBtn) {
          const card = selectBtn.closest('[data-product-id]');
          if (!card) return;
          this.toggleSelect(card.getAttribute('data-product-id'));
        }
      }

      // Simple products (no Color/Size options) are selected directly by clicking the image.
      toggleSelect(id) {
        const product = this.findProduct(id);
        if (!product) return;

        if (product.hasColor || product.hasSize) {
          // This product requires swatch selections instead of a direct toggle.
          return;
        }

        const variantKey = String(product.variantId);

        if (this.selected.has(variantKey)) {
          this.removeProduct(variantKey);
          return;
        }

        if (this.maxQuantity && this.totalQty() >= this.maxQuantity) {
          // Cap reached (e.g. a "buy any 2" offer already has 2 items) — a
          // new product can't be added until one is removed.
          return;
        }

        this.selected.set(variantKey, {
          productId: id,
          qty: 1,
          variantId: product.variantId,
          price: product.price,
          priceCents: product.priceCents,
          discountedPrice: product.discountedPrice,
          discountedPriceCents: product.discountedPriceCents,
          compareAtPrice: product.compareAtPrice,
          compareAtPriceCents: product.compareAtPriceCents,
          image: product.image,
          choices: {}
        });
        this.render();
      }

      // Products with Color/Size options are picked in two steps: choosing
      // Color/Size only updates the product's PENDING choice (never touches
      // the bundle); the shopper must click "Select Item" to confirm that
      // pending choice and add/update it as a bundle entry. Confirming a
      // different variant for the same product adds a separate entry — it
      // never removes a previously confirmed selection.
      selectSwatch(id, optionType, value) {
        const product = this.findProduct(id);
        if (!product) return;

        const pending = this.pendingChoices.get(id) || {};

        // Never allow picking a value that has no path to an available
        // variant at all (fully sold-out color, or a size with no stock in
        // the currently-chosen color).
        if (!this.isOptionValueAvailable(product, optionType, value, pending)) {
          return;
        }

        let sizeCleared = false;
        if (optionType === 'color' && product.hasSize) {
          // Color changed: keep the previously-chosen size whenever
          // possible. Only clear it (prompting a fresh size pick) if that
          // size doesn't exist / isn't in stock for the new color.
          pending.color = value;
          if (pending.size && !this.isOptionValueAvailable(product, 'size', pending.size, pending)) {
            pending.size = null;
            sizeCleared = true;
          }
        } else {
          pending[optionType] = value;
        }

        this.pendingChoices.set(id, pending);

        const card = this.grid ? this.grid.querySelector('[data-product-id="' + CSS.escape(id) + '"]') : null;

        if (optionType === 'color' && card) {
          this.updateCardImage(card, this.getColorImage(product, value));
        }

        const colorOk = !product.hasColor || pending.color;
        const sizeOk = !product.hasSize || pending.size;
        const noteEl = card ? card.querySelector('[data-swatch-note]') : null;

        if (colorOk && sizeOk) {
          const variant = this.matchVariant(product, pending);
          if (noteEl) noteEl.hidden = !!(variant && variant.available);
        } else if (noteEl) {
          // Not a complete combination yet. Only surface the note when we
          // just invalidated a previously-picked size (prompting a new size
          // choice); stay quiet otherwise (e.g. nothing picked yet).
          noteEl.hidden = !sizeCleared;
        }

        // Choosing/changing Color or Size never adds, removes, or updates a
        // bundle entry by itself — only confirmSelection() (the "Select
        // Item" button) does that. render() below just refreshes swatch
        // states and the button's enabled/disabled state.
        this.render();
      }

      // Commits the product's current pending Color/Size choice as a bundle
      // entry (called when the shopper clicks "Select Item"). No-ops if the
      // pending choice isn't a complete, in-stock variant. Never touches any
      // other product's — or this product's other variant's — entries.
      confirmSelection(id) {
        const product = this.findProduct(id);
        if (!product) return;

        const pending = this.pendingChoices.get(id) || {};
        const colorOk = !product.hasColor || pending.color;
        const sizeOk = !product.hasSize || pending.size;
        if (!colorOk || !sizeOk) return;

        const variant = this.matchVariant(product, pending);
        if (!variant || !variant.available) return;

        const variantKey = String(variant.id);
        const existing = this.selected.get(variantKey);

        if (!existing && this.maxQuantity && this.totalQty() >= this.maxQuantity) {
          // Cap reached — this would be a brand-new item, so refuse it.
          // Re-confirming a variant that's already selected is still fine,
          // since it doesn't change the total count.
          return;
        }

        this.selected.set(variantKey, {
          productId: id,
          qty: existing ? existing.qty : 1,
          variantId: variant.id,
          price: variant.price,
          priceCents: variant.priceCents,
          discountedPrice: variant.discountedPrice,
          discountedPriceCents: variant.discountedPriceCents,
          compareAtPrice: variant.compareAtPrice,
          compareAtPriceCents: variant.compareAtPriceCents,
          image: this.getColorImage(product, pending.color),
          choices: { color: pending.color || null, size: pending.size || null }
        });

        this.render();
      }

      // Whether `value` for `optionType` can still resolve to an available
      // variant given what else is currently chosen for this product.
      // Colors are only considered unavailable if they have zero stock in
      // any size; sizes are considered unavailable if they have no stock in
      // the currently-selected color (or, with no color chosen yet, no
      // stock in any color).
      isOptionValueAvailable(product, optionType, value, pending) {
        if (optionType === 'color') {
          if (!product.colorPosition) return true;
          const index = product.colorPosition - 1;
          return (product.variants || []).some((variant) => {
            return variant.available && variant.options && variant.options[index] === value;
          });
        }

        if (optionType === 'size') {
          if (!product.sizePosition) return true;
          const index = product.sizePosition - 1;
          const colorIndex = product.hasColor && product.colorPosition ? product.colorPosition - 1 : null;
          return (product.variants || []).some((variant) => {
            if (!variant.available || !variant.options || variant.options[index] !== value) return false;
            if (colorIndex !== null && pending.color) {
              return variant.options[colorIndex] === pending.color;
            }
            return true;
          });
        }

        return true;
      }

      // Finds the first variant matching the chosen color that has its own
      // image, so the product photo updates to that color the moment it's
      // picked — falls back to the card's default image otherwise.
      getColorImage(product, colorValue) {
        if (!product.hasColor || !colorValue || !product.colorPosition) {
          return product.image;
        }
        const index = product.colorPosition - 1;
        const match = (product.variants || []).find((variant) => {
          return variant.options && variant.options[index] === colorValue && variant.image;
        });
        return match ? match.image : product.image;
      }

      updateCardImage(card, imageUrl) {
        if (!imageUrl) return;
        const img = card.querySelector('.bundle-builder__card-image');
        if (!img) return;
        img.removeAttribute('srcset');
        img.src = imageUrl;
      }

      matchVariant(product, choices) {
        const target = (product.defaultOptionValues || []).slice();
        if (product.hasColor && product.colorPosition) {
          target[product.colorPosition - 1] = choices.color;
        }
        if (product.hasSize && product.sizePosition) {
          target[product.sizePosition - 1] = choices.size;
        }
        return (product.variants || []).find((variant) => {
          const options = variant.options || [];
          if (options.length !== target.length) return false;
          return options.every((value, index) => value === target[index]);
        });
      }

      changeQty(variantKey, delta) {
        const entry = this.selected.get(variantKey);
        if (!entry) return;

        const proposedQty = Math.max(1, entry.qty + delta);
        if (proposedQty === entry.qty) return;

        if (delta > 0 && this.maxQuantity) {
          // Total quantity across every OTHER entry, plus the proposed qty
          // for this entry, must never exceed the offer's cap (e.g. a
          // "buy any 2" offer can't reach 3 items via the + button).
          const totalOtherEntries = this.totalQty() - entry.qty;
          if (totalOtherEntries + proposedQty > this.maxQuantity) return;
        }

        entry.qty = proposedQty;
        this.selected.set(variantKey, entry);
        this.render();
      }

      removeProduct(variantKey) {
        this.selected.delete(variantKey);
        this.render();
      }

      buttonLabel() {
        const qty = Math.max(this.totalQty(), this.required);
        return this.buttonTemplate
          .replace('{quantity}', qty)
          .replace('{discount}', this.discount);
      }

      render() {
        // Some offers ("Buy any N" with a fixed pack size) have a hard cap
        // on total confirmed items; others (open-ended "N or more") don't.
        // this.maxQuantity is 0/falsy for uncapped offers.
        const countNow = this.totalQty();
        const capReached = !!(this.maxQuantity && countNow >= this.maxQuantity);

        if (this.grid) {
          this.grid.querySelectorAll('[data-product-id]').forEach((card) => {
            const id = card.getAttribute('data-product-id');
            const isSelected = this.isProductSelected(id);

            card.classList.toggle('is-selected', isSelected);

            const selectBtn = card.querySelector('[data-select-toggle]');
            if (selectBtn) selectBtn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

            const pending = this.pendingChoices.get(id) || {};
            const product = this.findProduct(id);

            // Simple products (no Color/Size) are selected directly by
            // clicking the card — block picking a NEW one once the cap is
            // reached (an already-selected card stays clickable so it can
            // still be removed).
            if (product && !product.hasColor && !product.hasSize) {
              card.classList.toggle('is-disabled', capReached && !isSelected);
            }

            card.querySelectorAll('[data-option-value]').forEach((swatchEl) => {
              const row = swatchEl.closest('[data-option-type]');
              const optionType = row ? row.getAttribute('data-option-type') : null;
              const value = swatchEl.getAttribute('data-option-value');
              const isActive = !!(optionType && pending[optionType] === value);
              const isAvailable = !product || !optionType || this.isOptionValueAvailable(product, optionType, value, pending);

              if (swatchEl.tagName === 'INPUT') {
                swatchEl.checked = isActive;
              } else {
                swatchEl.classList.toggle('is-active', isActive);
                swatchEl.setAttribute('aria-pressed', isActive ? 'true' : 'false');
              }

              swatchEl.disabled = !isAvailable;
              swatchEl.setAttribute('aria-disabled', String(!isAvailable));
              // For inputs, the visible swatch/text is the wrapping <label>,
              // not the (visually hidden) input itself — style that instead.
              const visualTarget = swatchEl.tagName === 'INPUT' ? swatchEl.closest('label') : swatchEl;
              if (visualTarget) visualTarget.classList.toggle('is-unavailable', !isAvailable);
            });

            const confirmBtn = card.querySelector('[data-select-variant]');
            if (confirmBtn && product) {
              const colorOk = !product.hasColor || pending.color;
              const sizeOk = !product.hasSize || pending.size;
              const readyVariant = colorOk && sizeOk ? this.matchVariant(product, pending) : null;
              const canConfirm = !!(readyVariant && readyVariant.available);
              // Once the offer's cap is reached, every "Select Item" button
              // in this builder is disabled — a customer can't confirm a
              // 3rd item on a "buy any 2" offer no matter what's pending.
              confirmBtn.disabled = !canConfirm || capReached;
              confirmBtn.setAttribute('aria-disabled', String(!canConfirm || capReached));
            }
          });
        }

        // Total selected quantity. For capped offers this can't exceed
        // maxQuantity (enforced above); for uncapped offers it can keep
        // growing past the minimum required.
        const count = this.totalQty();
        const ready = count >= this.required;

        if (this.counterEl) {
          // Once the minimum is met, show count/count (e.g. "4 / 4") so the
          // counter always reflects the real, uncapped quantity selected.
          const displayRequired = ready ? count : this.required;
          this.counterEl.textContent = count + ' / ' + displayRequired + ' items selected';
          this.counterEl.classList.toggle('is-complete', ready);
        }

        if (this.listEl) {
          this.listEl.innerHTML = '';
          this.selected.forEach((entry, key) => {
            const product = this.findProduct(entry.productId);
            if (!product) return;
            this.listEl.appendChild(this.buildRow(product, entry, key, capReached, ready));
          });
          this.listEl.hidden = count === 0;
        }

        if (this.addBtn) {
          this.addBtn.disabled = !ready;
          this.addBtn.setAttribute('aria-disabled', String(!ready));
        }
        if (this.labelEl) {
          this.labelEl.textContent = this.buttonLabel();
        }
      }

      buildRow(product, entry, key, capReached, ready) {
        const row = document.createElement('div');
        row.className = 'bundle-builder__selected-row';
        row.setAttribute('data-selected-row', '');
        row.setAttribute('data-product-id', product.id);
        row.setAttribute('data-entry-key', key);

        const image = document.createElement('img');
        image.className = 'bundle-builder__selected-image';
        image.src = entry.image || product.image || '';
        image.alt = product.title || '';
        image.width = 48;
        image.height = 48;
        image.loading = 'lazy';
        row.appendChild(image);

        const info = document.createElement('div');
        info.className = 'bundle-builder__selected-info';

        const titleEl = document.createElement('p');
        titleEl.className = 'bundle-builder__selected-title';
        titleEl.textContent = product.title || '';
        info.appendChild(titleEl);

        const choiceParts = [entry.choices && entry.choices.color, entry.choices && entry.choices.size].filter(Boolean);
        if (choiceParts.length) {
          const optsEl = document.createElement('p');
          optsEl.className = 'bundle-builder__selected-options';
          optsEl.textContent = choiceParts.join(' · ');
          info.appendChild(optsEl);
        }

        if (this.showPrices) {
          const priceEl = document.createElement('p');
          priceEl.className = 'bundle-builder__selected-price';
          const qty = entry.qty || 1;

          const unitCents = typeof entry.priceCents === 'number' ? entry.priceCents : null;
          const unitDiscountedCents = typeof entry.discountedPriceCents === 'number' ? entry.discountedPriceCents : null;
          const unitCompareAtCents = typeof entry.compareAtPriceCents === 'number' ? entry.compareAtPriceCents : null;

          const original =
            unitCents != null
              ? formatMoneyCents(unitCents * qty, this.moneyFormat, this.currencyCode)
              : entry.price || product.price || '';
          const discounted =
            unitDiscountedCents != null
              ? formatMoneyCents(unitDiscountedCents * qty, this.moneyFormat, this.currencyCode)
              : entry.discountedPrice || '';

          // The bundle-discount strikethrough (offer-level % / fixed-amount
          // off, e.g. the Henley product) only makes sense once the shopper
          // has actually qualified for this offer's discount (e.g. 2/2
          // items selected) — below that threshold there's no bundle
          // discount to show yet, so the "current" price is just the plain
          // per-item price.
          const bundleDiscountApplies = ready && discounted && discounted !== original;
          const currentCents = bundleDiscountApplies ? unitDiscountedCents : unitCents;
          const current = bundleDiscountApplies ? discounted : original;

          // Shopify's own compare_at_price is a separate, independent
          // concept from the bundle discount above: it comes straight from
          // the product/variant catalog data (never calculated from the
          // bundle discount %) and should be shown as the crossed-out price
          // any time it's set — regardless of whether this offer's bundle
          // discount has kicked in yet.
          const hasCompareAt = unitCompareAtCents != null && currentCents != null && unitCompareAtCents > currentCents;

          if (hasCompareAt) {
            const compareAt = formatMoneyCents(unitCompareAtCents * qty, this.moneyFormat, this.currencyCode);
            const originalEl = document.createElement('s');
            originalEl.className = 'bundle-builder__selected-price-original';
            originalEl.textContent = compareAt;
            const discountedEl = document.createElement('span');
            discountedEl.className = 'bundle-builder__selected-price-discounted';
            discountedEl.textContent = current;
            priceEl.appendChild(originalEl);
            priceEl.appendChild(discountedEl);
          } else if (bundleDiscountApplies) {
            const originalEl = document.createElement('s');
            originalEl.className = 'bundle-builder__selected-price-original';
            originalEl.textContent = original;
            const discountedEl = document.createElement('span');
            discountedEl.className = 'bundle-builder__selected-price-discounted';
            discountedEl.textContent = discounted;
            priceEl.appendChild(originalEl);
            priceEl.appendChild(discountedEl);
          } else {
            priceEl.textContent = current;
          }
          info.appendChild(priceEl);
        }
        row.appendChild(info);

        if (this.showQty) {
          const qtyWrap = document.createElement('div');
          qtyWrap.className = 'bundle-builder__qty';
          qtyWrap.innerHTML =
            '<button type="button" data-qty-minus aria-label="Decrease quantity">' + QTY_MINUS_SVG + '</button>' +
            '<span class="bundle-builder__qty-value">' + entry.qty + '</span>' +
            '<button type="button" data-qty-plus aria-label="Increase quantity">' + QTY_PLUS_SVG + '</button>';
          const plusBtn = qtyWrap.querySelector('[data-qty-plus]');
          if (plusBtn) {
            // Disabled once the offer's total-item cap is reached (e.g. a
            // "buy any 2" offer already holding 2 items) — incrementing any
            // row's quantity from here would push the total above the cap.
            plusBtn.disabled = capReached;
            plusBtn.setAttribute('aria-disabled', String(capReached));
          }
          row.appendChild(qtyWrap);
        }

        if (this.showRemove) {
          const removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'bundle-builder__remove';
          removeBtn.setAttribute('data-remove', '');
          removeBtn.setAttribute('aria-label', 'Remove ' + (product.title || 'item'));
          removeBtn.innerHTML = REMOVE_SVG;
          row.appendChild(removeBtn);
        }

        return row;
      }

      async addToCart() {
        if (this.totalQty() < this.required || this._submitting) return;
        // Final state-level safeguard: a capped offer (e.g. "buy any 2")
        // must never submit more than maxQuantity total items, regardless
        // of how selection/quantity state was reached.
        if (this.maxQuantity && this.totalQty() > this.maxQuantity) return;

        const items = [];
        this.selected.forEach((entry) => {
          if (!entry.variantId) return;
          items.push({
            id: entry.variantId,
            quantity: entry.qty,
            properties: { _bundle_offer: this.offerLabel }
          });
        });

        if (!items.length) return;

        this._submitting = true;
        if (this.addBtn) this.addBtn.disabled = true;
        const originalLabel = this.labelEl ? this.labelEl.textContent : '';
        if (this.labelEl) this.labelEl.textContent = 'Adding...';
        if (this.errorEl) this.errorEl.hidden = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || err.message || 'Could not add items to cart');
          }

          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();

          document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart } }));
          document.dispatchEvent(new CustomEvent('drawer:open'));

          this.selected.clear();
          this.pendingChoices.clear();
          this.render();
        } catch (err) {
          console.error('[bundle-builder] Add to cart error:', err);
          if (this.errorEl) {
            this.errorEl.textContent = err.message || 'Something went wrong. Please try again.';
            this.errorEl.hidden = false;
          }
          if (this.labelEl) this.labelEl.textContent = originalLabel;
        } finally {
          this._submitting = false;
          if (this.addBtn) {
            this.addBtn.disabled = this.totalQty() < this.required;
          }
        }
      }
    }

    customElements.define('bundle-offer-block', BundleOfferBlock);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
